import { useContext } from 'react';

import { useCapability } from '@vimeo/core/hooks/use-capability/useCapability';
import { ViewerContext } from '@vimeo/viewer';

export const useSearchCapabilities = () => {
  const viewer = useContext(ViewerContext);

  const {
    capabilities: { hasPaid },
  } = useCapability(['hasPaid']);

  const {
    capabilities: {
      hasPublicSearchDisabled,
      hasEnterprise,
      hasAutoClosedCaptions,
      hasOcrSearch,
      hasPrecisionSearch,
      hasInVideoSearch,
      hasContentSpaceEnabled,
    },
  } = useCapability(
    [
      'hasPublicSearchDisabled',
      'hasEnterprise',
      'hasAutoClosedCaptions',
      'hasOcrSearch',
      'hasPrecisionSearch',
      'hasInVideoSearch',
      'hasContentSpaceEnabled',
    ],
    viewer?.teamUser?.ownerId,
  );
  const isFromCopyrightRestrictedRegion = viewer?.isFromCopyrightRestrictedRegion;
  const hasPublicSearch =
    !hasPublicSearchDisabled && !isFromCopyrightRestrictedRegion && !viewer?.isEnterpriseSite;
  const hasSearchTypesDropdown = !!viewer?.user && hasPublicSearch;

  return {
    hasEnterprise,
    hasPublicSearchDisabled: !hasPublicSearch,
    hasCaptionsSearch: hasAutoClosedCaptions,
    hasOcrSearch,
    hasSearchTypesDropdown,
    hasPrecisionSearch,
    hasInVideoSearch,
    canSeeViewerHome: !viewer?.isSimplifiedSite,
    hasTemplates: !viewer?.isSimplifiedSite,
    hasOmnisearch: !(!viewer?.user && isFromCopyrightRestrictedRegion), // if a user is logged out AND from a copyright restricted region, remove omnisearch
    hasContentSpaceEnabled,
    hasPaid,
  };
};
